
import _ from 'lodash';
import Vue from 'vue';
import KeyList from './key-list.vue';
import globalEventBus, { events } from '@/event';
import ElementUI from 'element-ui';
import { isTest, isDevelopment, NODE_ENV, TAG } from '@com/config/env';

var latchkeys = [];

export default {
  components: {
    KeyList: KeyList
  },

  data: function data() {
    return {
      keys: [],
      visible: false,
      vueVersion: Vue.version,
      eleVersion: ElementUI.version,
      version: TAG,
      env: NODE_ENV
    };
  },


  computed: {
    isDebug: function isDebug() {
      return isDevelopment || isTest || this.$route.query.debug === '9527';
    }
  },

  watch: {
    $route: function $route() {
      latchkeys = [];
      this.keys = [];
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isDebug && globalEventBus.$on(events.PERMISSION.CATCH, function (_ref) {
      var latchkey = _ref.latchkey;

      if (!latchkeys.some(function (item) {
        return item === latchkey;
      })) {
        latchkeys = latchkeys.concat(latchkey);
      }
      _this.keys = _.uniq(latchkeys);
    });
  }
};